import React, { useEffect } from 'react';

import { Row, Label, Button } from 'reactstrap';
import withOpenState from './withOpenState';

const ToggleModalButtonWithLabel = ({ ComponentModal = null, label, ...props }) => {
   useEffect(() => {
      if (props.modalOpenCb) {
         props.modalOpenCb(props.isOpen);
      }
   }, [props.isOpen]);

   return (
      <div>
         <Row noGutters>
            <Label onClick={props.toggleIsOpen}>
               { label }
            </Label>
            <Button
               color='link'
               type='button'
               onClick={props.toggleIsOpen}
            >
               <i className='far fa-chevron-circle-right'/>
            </Button>
         </Row>
         {
            props.isOpen && ComponentModal && <ComponentModal { ...props }/>
         }
      </div>
   );
};

export default withOpenState(ToggleModalButtonWithLabel);
